export default __webpack_public_path__ + "fonts/82a07b3978406fefa91e6b84464a83ea.svg";